
import errorHandler from './errorHandler'
import api from '../../api'

export function undoLike(payload, next){
        api.delete("/twitter/tweets/" + payload.query.tweetId + ".like", (err, data) => {
            if(err) return next(err, null);
            next(null, data);
        })   
    }



// WEBPACK FOOTER //
// ./src/libs/twitter/undoLike.js